export const accountSetupPollingLimit = 180;
export const accountSetupPollingInterval = 5000;
